// eslint-disable-next-line import/prefer-default-export
export const PHONE_ALLOWED_CHARACTERS_REGEX = /[^0-9+]/g;
